import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  DeliverableItem,
  GetDeliverySolutionsApplicationErrors,
  GetDeliverySolutionsOptions,
  GetDeliverySolutionsResponse,
  getDeliverySolutions as universalGetDeliverySolutions,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function getDeliverySolutions(
  httpClient: HttpClient
): GetDeliverySolutionsSignature {
  return (
    lineItems: DeliverableItem[],
    options?: NonNullablePaths<
      GetDeliverySolutionsOptions,
      `currency` | `destination`,
      2
    >
  ) =>
    universalGetDeliverySolutions(
      lineItems,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetDeliverySolutionsSignature {
  /**
   * Get Delivery Solutions for the given line items from all relevant delivery carriers
   * @param - list of items to delivery that each of them points to delivery profile and delivery rule.
   * @returns Each delivery option has a list of items that can be delivered by it - the chosen one
   * on Errors throw a business error from TC to catch and trigger destination completion
   */
  (
    lineItems: DeliverableItem[],
    options?: NonNullablePaths<
      GetDeliverySolutionsOptions,
      `currency` | `destination`,
      2
    >
  ): Promise<
    NonNullablePaths<
      GetDeliverySolutionsResponse,
      | `deliverySolutions`
      | `deliverySolutions.${number}.code`
      | `deliverySolutions.${number}.title`
      | `deliverySolutions.${number}.logistics.pickupDetails.pickupMethod`
      | `deliverySolutions.${number}.cost.price`
      | `deliverySolutions.${number}.cost.currency`
      | `deliverySolutions.${number}.cost.deliveryPrice.amount`
      | `deliverySolutions.${number}.cost.deliveryPrice.convertedAmount`
      | `deliverySolutions.${number}.cost.deliveryPrice.formattedAmount`
      | `deliverySolutions.${number}.cost.deliveryPrice.formattedConvertedAmount`
      | `errors`
      | `errors.${number}.errorDetails.applicationError.code`
      | `errors.${number}.errorDetails.applicationError.description`,
      6
    > & {
      __applicationErrorsType?: GetDeliverySolutionsApplicationErrors;
    }
  >;
}

export {
  AccountInfo,
  AdditionalCost,
  Address,
  AddressLocation,
  AddressStreetOneOf,
  ApplicableLineItems,
  ApplicationError,
  Carrier,
  CatalogReference,
  DeliverableItem,
  DeliveryAllocation,
  DeliveryCarrierError,
  DeliveryCost,
  DeliveryLogistics,
  DeliveryRatesGateway,
  DeliveryReference,
  DeliverySolution,
  DeliveryTimeSlot,
  Details,
  DetailsKindOneOf,
  Dimensions,
  DimensionsUnit,
  ExtendedFields,
  ExternalReference,
  FieldViolation,
  FullAddressContactDetails,
  GetDeliverySolutionsOptions,
  GetDeliverySolutionsRequest,
  GetDeliverySolutionsResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  MessageEnvelope,
  MissingDefaultDeliveryProfileEvent,
  MultiCurrencyPrice,
  PhysicalProperties,
  PickupDetails,
  PickupMethod,
  Region,
  RuleType,
  StreetAddress,
  Subdivision,
  SubdivisionType,
  SubscriptionFrequency,
  SubscriptionSettings,
  SystemError,
  UserPreference,
  ValidationError,
  VatId,
  VatType,
  WebhookIdentityType,
  WeightUnit,
} from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';
